export default __webpack_public_path__ + "static/media/HPE-PROLIANT-DL325-REAR.aa5ffe44.png";